import script from "./DonutChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DonutChart.vue?vue&type=script&setup=true&lang=js"

import "./DonutChart.vue?vue&type=style&index=0&id=3d0c4fcb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d0c4fcb"]])

export default __exports__